:host {
  @include form-input;
  display: block;
  padding: 7px 20px 7px;
  position: relative;
  display: flex;
  flex-direction: row;
  > div {
    padding-right: 10px;
  }
  select {
    -webkit-appearance: none;
    border: 0;
    color: transparent;
    background-color: transparent;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100011;
    &:focus-visible {
      outline-color: var(--av-color-focus-outline);
    }
    option {
      color: var(--av-card-color);
    }
  }

  i {
    @include arrow-down;
  }
  // i.av-select-chevron-dark {
  //   border-right: 2px solid var(--av-font-color-light);
  //   border-bottom: 2px solid var(--av-font-color-light);
  // }
}
